import React from 'react'
import { navigate } from '@reach/router'
import { useGlobal } from './GlobalContext'
import { isEmptyObject } from '../utils/helpers/helpers'
import { listaInfosPagamento } from '../api/pagamento.servico'
import { cadastraCartao } from '../api/cartaoCredito.servico'
import { getBoletoFuturo, getSegundaVia } from '../api/boletoBancario.servico'
import { getProximosMesesBoletoTrimestral } from '../containers/Modalidade/PagamentoBoletoBancario/BoletoFuturo/constantsBoletoFuturo'
import { getVendasPorAssinatura } from '../api/assinatura.servico'

const BoletoBancarioContext = React.createContext()

function BoletoBancarioProvider( props ) {
  const [ state, setState ] = React.useState( {
    'codigoBarras': null,
    'infosPagamento': {},
    'proximosMesesBoletoTrimestral': null,
    'urlBoleto': null
  } )

  const value = React.useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <BoletoBancarioContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useBoletoBancario() {
  const context = React.useContext( BoletoBancarioContext )
  const { modalidadeURL, setErroRequisicao } = useGlobal()

  if ( !context ) {
    throw new Error( 'useBoletoBancario deve ser usado dentro de BoletoBancarioProvider' )
  }

  const { state, setState } = context

  const setInfosPagamento = infosPagamento => {
    setState( ( prevState ) => ( {
      ...prevState,
      infosPagamento
    } ) )
  }

  const setCodigoBarras = codigoBarras => {
    setState( ( prevState ) => ( {
      ...prevState,
      codigoBarras
    } ) )
  }

  const setProximosMesesBoletoTrimestral = proximosMesesBoletoTrimestral => {
    setState( ( prevState ) => ( {
      ...prevState,
      proximosMesesBoletoTrimestral
    } ) )
  }

  const setUrlBoleto = urlBoleto => {
    setState( ( prevState ) => ( {
      ...prevState,
      urlBoleto
    } ) )
  }

  const getInfosPagamento = async( idAssinatura ) => {
    try {
      const infosPagamentoResponse = await listaInfosPagamento( idAssinatura )
      const [ infosPagamentoUltimaVenda ] = await getVendasPorAssinatura( idAssinatura )
      if ( !isEmptyObject( infosPagamentoResponse.data ) && !isEmptyObject( infosPagamentoUltimaVenda ) ) {
        const infosPagamento = infosPagamentoResponse.data
        const valorLiquidoSemDesconto = Number( infosPagamentoUltimaVenda.valor_bruto ) + Number( infosPagamentoUltimaVenda.valor_frete )
        const totalDescontos = Number( infosPagamentoUltimaVenda.desconto_geral ) + Number( infosPagamentoUltimaVenda.desconto_frete ) + Number( infosPagamentoUltimaVenda.desconto_kit )
        infosPagamento.valorFrete = Number( infosPagamentoUltimaVenda.valor_frete )
        infosPagamento.valorLiquido = valorLiquidoSemDesconto - totalDescontos
        infosPagamento.parcelas = infosPagamentoUltimaVenda.parcelas

        setInfosPagamento( infosPagamento )

        const meses = getProximosMesesBoletoTrimestral( infosPagamentoResponse.data.mesTagUltimoPedidoPago.numero )
        setProximosMesesBoletoTrimestral( meses )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const getBoleto = async idAssinatura => {
    try {
      const response = await getBoletoFuturo( idAssinatura )
      if ( !isEmptyObject( response.data ) ) {
        setCodigoBarras( response.data.assinatura.pagamento.boleto.codigoBarras )
        setUrlBoleto( response.data.assinatura.pagamento.boleto.url )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const getSegundaViaBoleto = async idAssinatura => {
    try {
      const response = await getSegundaVia( idAssinatura )
      if ( !isEmptyObject( response.data ) ) {
        setCodigoBarras( response.data.assinatura.codigoBarras )
        setUrlBoleto( response.data.url )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const trocarFormaPagamento = async( cartao, idAssinatura ) => {
    const dados = {
      'assinatura': idAssinatura,
      'cartao_credito': { ...cartao }
    }

    try {
      const response = await cadastraCartao( dados )
      if ( response ) {
        navigate( `${modalidadeURL}/pagamento` )
      }
    } catch ( erro ) {
      const { message } = erro.response.data.errors[ 0 ] || null
      if ( message ) {
        const descricaoErro = {
          'descricao': message,
          'titulo': 'Houve um erro!'
        }
        setErroRequisicao(
          erro.response.status || erro.request.status,
          descricaoErro
        )
      } else {
        setErroRequisicao( erro.response.status )
      }
    }
  }

  return {
    'codigoBarras': state.codigoBarras,
    getBoleto,
    getInfosPagamento,
    getSegundaViaBoleto,
    'infosPagamento': state.infosPagamento,
    'proximosMesesBoletoTrimestral': state.proximosMesesBoletoTrimestral,
    trocarFormaPagamento,
    'urlBoleto': state.urlBoleto
  }
}

export { BoletoBancarioProvider, useBoletoBancario }
